
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc5a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc5a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h5VcY", function(module, exports) {

$parcel$export(module.exports, "getTenantHostName", () => $c71f47af2d8f4076$export$51cee75883360c2c);
const $c71f47af2d8f4076$export$51cee75883360c2c = async ()=>{
    // if (!window.browser) {
    // 	return;
    // }
    // if (window.ENV.NEXT_PUBLIC_NODE_ENV === "development") {
    // 	return;
    // }
    let response;
    let tId = window.location.hostname.split(".")[0].replace("127", "alpha");
    tId = tId.replace("-cdev", "");
    if (tId === "consignment-tracking" || tId === "dynamic-discussion") tId = "alpha";
    // tId = "alpha";
    try {
        // window.ENV.ORGANISATION_NAME = tId;
        response = await $.ajax({
            url: `https://developerplatform.preprod.dlv2.fxtrt.io/app/core-api/tenant?orgShortName=${tId}`,
            method: "GET"
        });
    } catch (err) {
        console.error(err);
    }
    return response?.data;
};

});


var $h5VcY = parcelRequire("h5VcY");
const $f7544f7c37939b09$export$5c9217d9513756b1 = (name)=>{
    var queryString = window.location.search.substring(1);
    var queryParams = queryString.split("&");
    for(var i = 0; i < queryParams.length; i++){
        var param = queryParams[i].split("=");
        if (param[0] === name) return decodeURIComponent(param[1]);
    }
    // If the name was not found, return null
    return null;
};


const $9869123fc355fae5$var$riders = {
    "singular": "Rider",
    "plural": "Riders"
};
const $9869123fc355fae5$var$shipments = {
    "singular": "Shipment",
    "plural": "Shipments"
};
const $9869123fc355fae5$export$8bd4336e9f3a70cf = {
    riders: $9869123fc355fae5$var$riders,
    shipments: $9869123fc355fae5$var$shipments
};
const $9869123fc355fae5$export$a7c25f30fdb2d72b = (list)=>{
    for(let item in list){
        let key = item;
        console.log(key);
        if ($9869123fc355fae5$export$8bd4336e9f3a70cf[key]) {
            console.log(list[key]?.alias);
            $9869123fc355fae5$export$8bd4336e9f3a70cf[key].singular = list[key]?.alias?.singular ?? $9869123fc355fae5$export$8bd4336e9f3a70cf[key].singular;
            $9869123fc355fae5$export$8bd4336e9f3a70cf[key].plural = list[key]?.alias?.plural ?? $9869123fc355fae5$export$8bd4336e9f3a70cf[key].plural;
        }
    }
};


const $4ba290e3bd95c603$var$PEC = JSON.parse(sessionStorage.getItem("labels_config"));
const $4ba290e3bd95c603$export$ba28980b1875395d = {
    "E-020-R-0046": "Shipment Created",
    "E-012-R-0095": "Added to dispatch",
    "E-012-R-0099": "Customer Call Placed",
    "E-012-R-0067": "Container Associated With New Workorder",
    "E-013-R-0059": "Entity Reopened By Client",
    "E-021-R-0063": "Picked Up",
    "E-006-R-0063": "Picked Up",
    "E-010-R-0041": "Delivered To Consignee",
    "E-010-R-0042": "Delivered To Security",
    "E-010-R-0043": "Delivered to Other As Per Consignee",
    "E-021-R-0013": "Delivery Rescheduled",
    "E-021-R-0020": "Payment Mode/Amount Dispute",
    "E-021-R-0022": "Customer Asked For Open Delivery",
    "E-021-R-0023": "Consignee Opened Package And Refused To Accept",
    "E-021-R-0024": "Entry Restricted Area",
    "E-021-R-0025": "Address Quality Issue",
    "E-021-R-0026": "Not Attempted",
    "E-021-R-0027": "Consignee Refused Order",
    "E-021-R-0028": "Consignee Seized Package",
    "E-021-R-0029": "Consignee Not Available",
    "E-021-R-0035": "Delivery Unsuccessful",
    "E-021-R-0036": "Delivery Unsuccessful",
    // "E-011-R-0066": "Attempt count exhausted",
    "E-011-R-0058": "Cancelled as per client request",
    "E-011-R-0102": "Cancelled as per consignee request",
    "E-019-R-0082": "Job Creation Failed",
    "E-012-R-0068": "Rider Assigned",
    "E-005-R-0068": "Rider Assigned",
    "E-005-R-0068": "Rider Assigned",
    "E-040-R-0121": "Consignor Refused Order",
    "E-040-R-0120": "Consignor Not Available",
    "E-040-R-0026": "Not Attempted",
    "E-040-R-0071": "Failed",
    "E-021-R-3001": "Customer Issue : Needs loading and unloading",
    "E-021-R-3002": "Customer Issue : Wrong pickup or drop location selected",
    "E-021-R-3003": "Customer Issue : Not able to contact customer",
    "E-021-R-3004": "Customer Issue : Placed the order by mistake",
    "E-021-R-3005": "Driver Issue : Driver refused pickup or unreachable",
    "E-021-R-3006": "Driver Issue : Driver behavior or vehicle issues",
    "E-021-R-3007": "Pickup time was too long",
    "E-040-R-0131": "Payment unsuccessful",
    "E-021-R-0131": "Payment unsuccessful",
    "E-021": "",
    "E-040": ""
};
const $4ba290e3bd95c603$export$1597ff4b064d820e = {
    "E-010-R-0041": "Delivered To Consignee",
    "E-010-R-0042": "Delivered To Security",
    "E-010-R-0043": "Delivered to Other As Per Consignee",
    "E-021-R-0013": "Delivery Rescheduled",
    "E-021-R-0020": "Payment Mode/Amount Dispute",
    "E-021-R-0022": "Customer Asked For Open Delivery",
    "E-021-R-0023": "Consignee Opened Package And Refused To Accept",
    "E-021-R-0024": "Entry Restricted Area",
    "E-021-R-0025": "Address Quality Issue",
    "E-021-R-0026": "Not Attempted",
    "E-021-R-0027": "Consignee Refused Order",
    "E-021-R-0028": "Consignee Seized Package",
    "E-021-R-0029": "Consignee Unavailable",
    "E-021-R-0035": "Delivery Unsuccessful",
    "E-021-R-0036": "Delivery Unsuccessful",
    "E-021-R-0035": "Delivery failed",
    "E-021-R-0036": "Delivery failed",
    "E-021-R-3001": "Customer Issue : Needs loading and unloading",
    "E-021-R-3002": "Customer Issue : Wrong pickup or drop location selected",
    "E-021-R-3003": "Customer Issue : Not able to contact customer",
    "E-021-R-3004": "Customer Issue : Placed the order by mistake",
    "E-021-R-3005": "Driver Issue : Driver refused pickup or unreachable",
    "E-021-R-3006": "Driver Issue : Driver behavior or vehicle issues",
    "E-021-R-3007": "Pickup time was too long",
    "E-021-R-0131": "Payment unsuccessful"
};
const $4ba290e3bd95c603$export$7fac4afed79e1ba9 = [
    "E-011-R-0058"
];
const $4ba290e3bd95c603$export$fbc26ae33bd1fca7 = {
    "E-020-R-0046": "Shipment Created",
    "E-021-R-0063": "Picked Up",
    "E-006-R-0063": "Picked Up"
};
const $4ba290e3bd95c603$export$93598a6a54685e4f = [
    "E-021-R-0063",
    "E-006-R-0063"
];
const $4ba290e3bd95c603$export$ef43ed1a1d4cf992 = [];
const $4ba290e3bd95c603$export$5fbe065f82ff2dec = [
    "E-010-R-0041",
    "E-010-R-0042",
    "E-010-R-0043"
];
const $4ba290e3bd95c603$export$ef331f13fbe04e74 = [
    "E-040-R-0120",
    "E-040-R-0121",
    "E-040-R-0071",
    "E-040-R-0026",
    "E-040-R-0131",
    "E-040"
];
const $4ba290e3bd95c603$export$8751a8cb08b2a1c7 = [
    ...$4ba290e3bd95c603$export$5fbe065f82ff2dec
];
const $4ba290e3bd95c603$export$c8ecc1ebe89d4f91 = [];
const $4ba290e3bd95c603$export$dffbaef5ea27a68f = [];
const $4ba290e3bd95c603$export$2974422dc9ef58c5 = [
    "E-021-R-0013",
    "E-021-R-0014",
    // "E-021-R-0020",
    // "E-021-R-0023",
    // "E-021-R-0024",
    // "E-021-R-0025",
    "E-021-R-0026",
    "E-021-R-0027",
    "E-021-R-0029",
    "E-011-R-0066",
    "E-021-R-3001",
    "E-021-R-3002",
    "E-021-R-3003",
    "E-021-R-3004",
    "E-021-R-3005",
    "E-021-R-3006",
    "E-021-R-3007",
    "E-021-R-0131",
    "E-021"
];
const $4ba290e3bd95c603$export$d0027f3a0bc3986a = [
    ...$4ba290e3bd95c603$export$2974422dc9ef58c5
];
const $4ba290e3bd95c603$export$9fc46618fc73cc01 = [
    "E-013-R-0069"
];
const $4ba290e3bd95c603$export$2cd16e5e5b930e8a = [
    ...$4ba290e3bd95c603$export$9fc46618fc73cc01
];
const $4ba290e3bd95c603$export$99b277757456e754 = [
    "E-012-R-0068",
    "E-005-R-0068"
];
const $4ba290e3bd95c603$export$4e09a66b1244f7be = {
    SUCCESS: [
        "E-012-R-0065"
    ],
    FAILURE: [
        "E-020-R-0069",
        "E-012-R-0064",
        "E-011-R-0066"
    ]
};
const $4ba290e3bd95c603$export$6178b602ab06e887 = [
    "E-013-R-0069",
    "E-011-R-0066"
];
const $4ba290e3bd95c603$export$68977cb6a4e54f58 = {
    rider: [
        ...$4ba290e3bd95c603$export$99b277757456e754
    ],
    pickup: [
        ...$4ba290e3bd95c603$export$ef43ed1a1d4cf992,
        ...$4ba290e3bd95c603$export$93598a6a54685e4f,
        ...$4ba290e3bd95c603$export$ef331f13fbe04e74
    ],
    delivery: [
        ...$4ba290e3bd95c603$export$dffbaef5ea27a68f,
        ...$4ba290e3bd95c603$export$2974422dc9ef58c5,
        ...$4ba290e3bd95c603$export$5fbe065f82ff2dec
    ],
    misc: [
        ...$4ba290e3bd95c603$export$4e09a66b1244f7be.SUCCESS,
        ...$4ba290e3bd95c603$export$4e09a66b1244f7be.FAILURE
    ],
    // Added new state for return
    reverse: [
        ...$4ba290e3bd95c603$export$dffbaef5ea27a68f,
        ...$4ba290e3bd95c603$export$2974422dc9ef58c5,
        ...$4ba290e3bd95c603$export$5fbe065f82ff2dec
    ]
}; // export const outForDeliveryStates = {
 // 	"E-021-R-0024": "Entry Restricted Area",
 // 	"E-021-R-0025": "Address Quality Issue",
 // 	"E-021-R-0026": "Not Attempted",
 // };



var $54da56340462fe8a$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$54da56340462fe8a$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


const $abd6ec586e6f8595$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $abd6ec586e6f8595$var$VERSION = 1; // serialized format version
const $abd6ec586e6f8595$var$HEADER_SIZE = 8;
class $abd6ec586e6f8595$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== $abd6ec586e6f8595$var$VERSION) throw new Error(`Got v${version} data when expected v${$abd6ec586e6f8595$var$VERSION}.`);
        const ArrayType = $abd6ec586e6f8595$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $abd6ec586e6f8595$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $abd6ec586e6f8595$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($abd6ec586e6f8595$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($abd6ec586e6f8595$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $abd6ec586e6f8595$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($abd6ec586e6f8595$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($abd6ec586e6f8595$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $abd6ec586e6f8595$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $abd6ec586e6f8595$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $abd6ec586e6f8595$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $abd6ec586e6f8595$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $abd6ec586e6f8595$var$swapItem(ids, coords, left, right);
        while(i < j){
            $abd6ec586e6f8595$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $abd6ec586e6f8595$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $abd6ec586e6f8595$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $abd6ec586e6f8595$var$swapItem(ids, coords, i, j) {
    $abd6ec586e6f8595$var$swap(ids, i, j);
    $abd6ec586e6f8595$var$swap(coords, 2 * i, 2 * j);
    $abd6ec586e6f8595$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $abd6ec586e6f8595$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $abd6ec586e6f8595$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}


const $2fa4452876a3c712$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $2fa4452876a3c712$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $2fa4452876a3c712$var$OFFSET_ZOOM = 2;
const $2fa4452876a3c712$var$OFFSET_ID = 3;
const $2fa4452876a3c712$var$OFFSET_PARENT = 4;
const $2fa4452876a3c712$var$OFFSET_NUM = 5;
const $2fa4452876a3c712$var$OFFSET_PROP = 6;
class $2fa4452876a3c712$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($2fa4452876a3c712$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $2fa4452876a3c712$var$fround($2fa4452876a3c712$var$lngX(lng));
            const y = $2fa4452876a3c712$var$fround($2fa4452876a3c712$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($2fa4452876a3c712$var$lngX(minLng), $2fa4452876a3c712$var$latY(maxLat), $2fa4452876a3c712$var$lngX(maxLng), $2fa4452876a3c712$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1 ? $2fa4452876a3c712$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $2fa4452876a3c712$var$OFFSET_PARENT] === clusterId) children.push(data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1 ? $2fa4452876a3c712$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $abd6ec586e6f8595$export$2e2bcd8739ae039)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $2fa4452876a3c712$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $2fa4452876a3c712$var$lngX(lng);
                py = $2fa4452876a3c712$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $2fa4452876a3c712$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $2fa4452876a3c712$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $2fa4452876a3c712$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $2fa4452876a3c712$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $2fa4452876a3c712$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $2fa4452876a3c712$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $2fa4452876a3c712$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $2fa4452876a3c712$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $2fa4452876a3c712$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $2fa4452876a3c712$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + $2fa4452876a3c712$var$OFFSET_ID],
        properties: $2fa4452876a3c712$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                $2fa4452876a3c712$var$xLng(data[i]),
                $2fa4452876a3c712$var$yLat(data[i + 1])
            ]
        }
    };
}
function $2fa4452876a3c712$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $2fa4452876a3c712$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $2fa4452876a3c712$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $2fa4452876a3c712$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $2fa4452876a3c712$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $2fa4452876a3c712$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $2fa4452876a3c712$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $2fa4452876a3c712$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6b01057b10dce3c0$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $6b01057b10dce3c0$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $6b01057b10dce3c0$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$6b01057b10dce3c0$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $6b01057b10dce3c0$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $6b01057b10dce3c0$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $6b01057b10dce3c0$export$57247bea612a5e84(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $6b01057b10dce3c0$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $6b01057b10dce3c0$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $6b01057b10dce3c0$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $6b01057b10dce3c0$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $6b01057b10dce3c0$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $6b01057b10dce3c0$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $6b01057b10dce3c0$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $6b01057b10dce3c0$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $6b01057b10dce3c0$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $6b01057b10dce3c0$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $6b01057b10dce3c0$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $6b01057b10dce3c0$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $6b01057b10dce3c0$export$d8a438b9a55dba76 extends $6b01057b10dce3c0$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $6b01057b10dce3c0$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $6b01057b10dce3c0$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $6b01057b10dce3c0$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $6b01057b10dce3c0$export$57ed47926628b770({
            position: $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $6b01057b10dce3c0$export$dfa3b6d6f10e5cac extends $6b01057b10dce3c0$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $6b01057b10dce3c0$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $6b01057b10dce3c0$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $6b01057b10dce3c0$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $6b01057b10dce3c0$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $6b01057b10dce3c0$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $6b01057b10dce3c0$export$f6cacfea2ccd84d3 extends $6b01057b10dce3c0$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $6b01057b10dce3c0$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $6b01057b10dce3c0$export$3c4c9430ac0fb1eb extends $6b01057b10dce3c0$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $6b01057b10dce3c0$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $2fa4452876a3c712$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $6b01057b10dce3c0$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $6b01057b10dce3c0$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $6b01057b10dce3c0$export$80a71135475bbaa7 extends $6b01057b10dce3c0$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $6b01057b10dce3c0$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new (0, $2fa4452876a3c712$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = {
            zoom: Math.round(input.map.getZoom()),
            view: $6b01057b10dce3c0$export$6341d7e267bda241(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        let changed = !(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(this.state, state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map, mapCanvasProjection: mapCanvasProjection }) {
        /* recalculate new state because we can't use the cached version. */ const state = {
            zoom: Math.round(map.getZoom()),
            view: $6b01057b10dce3c0$export$6341d7e267bda241(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $6b01057b10dce3c0$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $6b01057b10dce3c0$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $6b01057b10dce3c0$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $6b01057b10dce3c0$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $6b01057b10dce3c0$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($6b01057b10dce3c0$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6b01057b10dce3c0$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $6b01057b10dce3c0$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $6b01057b10dce3c0$var$extend($6b01057b10dce3c0$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b01057b10dce3c0$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($6b01057b10dce3c0$export$f87b0506a2cf0bc || ($6b01057b10dce3c0$export$f87b0506a2cf0bc = {}));
const $6b01057b10dce3c0$export$b434dc9855552644 = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $6b01057b10dce3c0$export$58bd9bb9fcf3dd4f extends $6b01057b10dce3c0$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $6b01057b10dce3c0$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $6b01057b10dce3c0$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $6b01057b10dce3c0$export$b434dc9855552644 }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $6b01057b10dce3c0$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $6b01057b10dce3c0$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $6b01057b10dce3c0$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$6b01057b10dce3c0$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $6b01057b10dce3c0$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$6b01057b10dce3c0$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $6b01057b10dce3c0$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$6b01057b10dce3c0$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $6b01057b10dce3c0$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $6b01057b10dce3c0$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}


async function $8551cf67c580172e$export$b08464e47b7a3a8(markerData) {
    // The location of Uluru
    const delhi = {
        lat: 28.6139,
        lng: 77.209
    };
    let position;
    if (markerData && markerData.length) position = markerData[0].position;
    else position = delhi;
    // Request needed libraries.
    //@ts-ignore
    const { Map: Map } = await google.maps.importLibrary("maps");
    let bounds = new google.maps.LatLngBounds();
    markerData.forEach((marker)=>{
        var googleMarker = new google.maps.LatLng(marker?.position?.lat, marker?.position?.lng);
        bounds.extend(googleMarker);
    });
    // The map, centered at Uluru
    const map = new Map(document.getElementById("map-container"), {
        zoom: 18,
        center: position,
        mapId: "DEMO_MAP_ID",
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });
    // Fit the map to the bounds
    if (markerData.length > 1) map.fitBounds(bounds);
    if (markerData.length == 0) map.setZoom(5);
    console.log(markerData);
    const markers = markerData.map((marker)=>new google.maps.Marker({
            position: marker.position,
            // label: marker.label,
            icon: marker.icon
        }));
    // Add a marker clusterer to manage the markers.
    new (0, $6b01057b10dce3c0$export$58bd9bb9fcf3dd4f)({
        markers: markers,
        map: map
    });
}



let $3f7da425cbef4cd8$var$map;
let $3f7da425cbef4cd8$var$markerCluster;
let $3f7da425cbef4cd8$var$markers = [];
let $3f7da425cbef4cd8$var$previousMarkerData = "";
async function $3f7da425cbef4cd8$export$c74460cc9b8dfbe7(markerData, onlyUpdateMarkers = false) {
    if ($3f7da425cbef4cd8$var$map && onlyUpdateMarkers) {
        $3f7da425cbef4cd8$var$updateMarkers(markerData);
        return;
    }
    const delhi = {
        lat: 28.6139,
        lng: 77.209
    };
    let position = markerData?.length ? markerData[0].position : delhi;
    //@ts-ignore
    const { Map: Map } = await google.maps.importLibrary("maps");
    if (!$3f7da425cbef4cd8$var$map) $3f7da425cbef4cd8$var$map = new Map(document.getElementById("map-container"), {
        zoom: 18,
        center: position,
        mapId: "DEMO_MAP_ID",
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });
    $3f7da425cbef4cd8$var$updateMarkers(markerData);
}
function $3f7da425cbef4cd8$var$updateMarkers(markerData) {
    const markerDataString = JSON.stringify(markerData);
    if (markerDataString === $3f7da425cbef4cd8$var$previousMarkerData) {
        console.log("No changes in marker data, skipping update.");
        return;
    }
    $3f7da425cbef4cd8$var$previousMarkerData = markerDataString;
    // Remove existing markers
    $3f7da425cbef4cd8$var$markers.forEach((marker)=>marker.setMap(null));
    $3f7da425cbef4cd8$var$markers = [];
    let bounds = new google.maps.LatLngBounds();
    markerData.forEach((markerInfo)=>{
        const marker = new google.maps.Marker({
            position: markerInfo.position,
            icon: markerInfo.icon,
            map: $3f7da425cbef4cd8$var$map
        });
        $3f7da425cbef4cd8$var$markers.push(marker);
        bounds.extend(marker.position);
    });
    if (markerData.length > 1) $3f7da425cbef4cd8$var$map.fitBounds(bounds);
    else if (markerData.length === 0) $3f7da425cbef4cd8$var$map.setZoom(5);
    if ($3f7da425cbef4cd8$var$markerCluster) $3f7da425cbef4cd8$var$markerCluster.clearMarkers();
    // Ensure MarkerClusterer is properly initialized
    $3f7da425cbef4cd8$var$markerCluster = new (0, $6b01057b10dce3c0$export$58bd9bb9fcf3dd4f)({
        markers: $3f7da425cbef4cd8$var$markers,
        map: $3f7da425cbef4cd8$var$map
    });
    console.log("Markers updated!");
}


const $eb2af9201e5d6d09$export$aa531ef9964b076d = {
    // UNATTEMPTED: "step",
    ATTEMPTED: "attempted",
    ONGOING: "step-pickup",
    COMPLETED: "step-completed",
    SUCCESS: "step-success",
    FAILED: "step-order-failed",
    PREVIOUS_FAILED: "sml-failed",
    PREVIOUS_SUCCESS: "sml-success-step"
};
const $eb2af9201e5d6d09$export$5ad47f54758f777 = {
    STEP: ".step",
    TITLE: ".title",
    DATE: ".date-text",
    CIRCLE: ".count-circle",
    UPDATES_ALL: ".allupdate-wrapper",
    INFO: ".info",
    LOADER: ".loader",
    REASONING: ".reasoning"
};
const $eb2af9201e5d6d09$export$cbb21fcb27c5c09a = {
    MAP: "#map-container",
    ORDER_ID: "#order-id-text",
    ESTIMATED_DATE: "#Estimated-Date-Text",
    ESTIMATED_TIME: "#Estimated-Time-Text",
    ORDER_STATE: "#order-state-text",
    RIDER_ASSIGNED: "#step-assigned",
    DELIVERY: "#step-delivered",
    PICKUP: "#step-pickup",
    PREVIOUS_RIDER_ASSIGN: "#previous-step-assigned",
    PREVIOUS_PICKUP: "#previous-step-pickup",
    PREVIOUS_DELIVERY: "#previous-step-delivery",
    PREVIOUS_ATTEMPT: "#previous-attempt-failed",
    WRAPPER: "#main-wrapper",
    ORDER_FAILED_DATE: "#order-failed-date",
    ORDER_FAILED_DATE_PICKUP: "#order-failed-date-pickup",
    RETURN: "#step-return",
    CONSIGNEE_DATA: "#consignee-data",
    PREVIOUS_ATTEMPT_FAILED_PICKUP: "#previous-attempt-failed-pickup",
    CONSIGNEE_NAME: "#consignee-name",
    CONSIGNEE_NUMBER: "#consignee-number",
    SHIPMENTS_MODAL: "#modal-wrapper"
};
const $eb2af9201e5d6d09$export$28139912552c032e = {
    "created:created": "Your order will be picked soon",
    "inProgress:scheduled": "Your order will be picked soon",
    "inProgress:assigned": "Your order will be picked up today",
    "inProgress:active": "Your order is arriving today",
    "closed:success": "Your order has been delivered successfully",
    "executed:success": "Your order has been delivered successfully",
    "executed:delivered": "Your order has been delivered successfully",
    "closed:failed": "Order not delivered",
    "executed:failed": "Order not delivered",
    "executed:undelivered": "Order not delivered",
    onhold: "Your order has been put on hold",
    "closed:closed": "Your order is completed",
    "inProgress:rescheduled": "Your order will be re-attempted"
};
const $eb2af9201e5d6d09$export$66adfd5446cb4c3d = {
    "created:created": "Your return order will be picked soon",
    "inProgress:scheduled": "Your return order will be picked soon",
    "inProgress:assigned": "Your return order will be picked up today",
    "inProgress:active": "Your return order has been picked up",
    "closed:success": "Your return order has been received",
    "executed:success": "Your return order has been received",
    "executed:delivered": "Your return order has been received",
    "closed:failed": "Your return order failed",
    "executed:failed": "Your return order failed",
    "executed:undelivered": "Your return order failed",
    onhold: "Your order has been put on hold",
    "closed:closed": "Your order is completed",
    "inProgress:rescheduled": "Your order will be re-attempted"
};


function $27c0c041de6aa09f$export$c87251e505708bc4(shipmentList = [], orderId) {
    const shipmentModal = document.querySelector((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).SHIPMENTS_MODAL);
    const searchInput = shipmentModal.querySelector(".shipments-modal-input");
    const previousBtn = shipmentModal.querySelector(".shipments-modal-previous");
    const nextBtn = shipmentModal.querySelector(".shipments-modal-next");
    const shipmentListWrapper = shipmentModal.querySelector(".shipments-modal-list");
    const shipmentListWrapperMweb = shipmentModal.querySelector(".shipments-modal-list-mweb");
    const shipmentsListContainer = shipmentModal.querySelector(".shipments-modal-list-wrapper");
    const shipmentsListContainerMweb = shipmentModal.querySelector(".shipments-modal-list-wrapper-mweb");
    const previousBtnText = shipmentModal.querySelector(".shipments-modal-previous-text");
    const nextBtnText = shipmentModal.querySelector(".shipments-modal-next-text");
    const previousBtnIcon = shipmentModal.querySelector(".shipments-modal-previous-icon");
    const nextBtnIcon = shipmentModal.querySelector(".shipments-modal-next-icon");
    const previousBtnIconDisabled = shipmentModal.querySelector(".shipments-modal-previous-icon-disabled");
    const nextBtnIconDisabled = shipmentModal.querySelector(".shipments-modal-next-icon-disabled");
    const shipmentsModalFooter = shipmentModal.querySelector(".shipments-modal-footer");
    const shipmentsModalHeading = shipmentModal.querySelector(".shipments-modal-heading");
    const shipmentsModalHeadingMweb = shipmentModal.querySelector(".shipments-modal-heading-mweb");
    const shipmentsModalNoResults = shipmentModal.querySelector(".shipments-modal-no-results");
    const shipmentsModalCross = shipmentModal.querySelector(".shipments-modal-cross");
    const shipmentsModalListHeader = shipmentModal.querySelector(".shipments-modal-list-header");
    const shipmentsModalListHeaderMweb = shipmentModal.querySelector(".shipments-modal-list-header-mweb");
    const PEC = JSON.parse(sessionStorage.getItem("labels_config"));
    let currentPage = 1;
    const itemsPerPage = 5;
    let searchFiltered = shipmentList;
    const disablePreviousBtn = ()=>{
        previousBtnIconDisabled.style.display = "block";
        previousBtnIcon.style.display = "none";
        previousBtnText.style.color = "#e0e3eb";
        previousBtn.style.cursor = "default";
    };
    const enablePreviousBtn = ()=>{
        previousBtnIconDisabled.style.display = "none";
        previousBtnIcon.style.display = "block";
        previousBtnText.style.color = "#525b7a";
        previousBtn.style.cursor = "pointer";
    };
    const disableNextBtn = ()=>{
        nextBtnIconDisabled.style.display = "block";
        nextBtnIcon.style.display = "none";
        nextBtnText.style.color = "#e0e3eb";
        nextBtn.style.cursor = "default";
    };
    const enableNextBtn = ()=>{
        nextBtnIconDisabled.style.display = "none";
        nextBtnIcon.style.display = "block";
        nextBtnText.style.color = "#525b7a";
        nextBtn.style.cursor = "pointer";
    };
    const searchFilter = ()=>{
        searchFiltered = shipmentList.filter((shipment)=>shipment.toLowerCase()?.includes(searchInput?.value?.toLowerCase() || ""));
    };
    const updatePagination = ()=>{
        if (currentPage === 1) disablePreviousBtn();
        else enablePreviousBtn();
        if (currentPage === Math.ceil(searchFiltered?.length / itemsPerPage)) disableNextBtn();
        else enableNextBtn();
        if (searchFiltered?.length <= itemsPerPage) shipmentsModalFooter.classList.add("hide");
        else shipmentsModalFooter.classList.remove("hide");
    };
    const filterList = (start, end)=>{
        searchFilter();
        const pageFiltered = searchFiltered.slice(start, end);
        return pageFiltered;
    };
    const createList = (filterList = [])=>{
        return filterList.map((item)=>`<span class="shipment-modal-list-item">${item}</span>`).join("");
    };
    const createListMweb = (filterList = [])=>{
        return filterList.map((item)=>`<span class="shipment-modal-list-item-mweb">${item}</span>`).join("");
    };
    const updateShipmentList = ()=>{
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        const filteredList = filterList(start, end);
        const createdList = createList(filteredList);
        shipmentListWrapper.innerHTML = createdList;
        if (createdList.length === 0) {
            shipmentsModalNoResults.classList.remove("hide");
            shipmentsListContainer.classList.add("hide");
            shipmentsModalFooter.classList.add("hide");
        } else {
            shipmentsModalNoResults.classList.add("hide");
            shipmentsListContainer.classList.remove("hide");
            shipmentsModalFooter.classList.remove("hide");
        }
        updatePagination();
    };
    const updateShipmentListMweb = ()=>{
        searchFilter();
        const createdList = createListMweb(searchFiltered);
        shipmentListWrapperMweb.innerHTML = createdList;
        if (createdList.length === 0) {
            shipmentsModalNoResults.classList.remove("hide");
            shipmentsListContainerMweb.classList.add("hide");
        } else {
            shipmentsModalNoResults.classList.add("hide");
            shipmentsListContainerMweb.classList.remove("hide");
        }
    };
    updateShipmentList();
    updateShipmentListMweb();
    shipmentsModalHeading.textContent = `${PEC?.shipments?.plural || ""} (${shipmentList.length || ""})`;
    shipmentsModalHeadingMweb.textContent = `Order ID #${orderId || ""}`;
    shipmentsModalListHeaderMweb.textContent = `${PEC?.shipments?.plural || ""}: ${shipmentList.length || ""}`;
    shipmentsModalListHeader.textContent = `${PEC?.shipments?.singular || ""} ID`;
    searchInput.placeholder = `Search by ${PEC?.shipments?.singular || ""} ID`;
    searchInput.addEventListener("input", ()=>{
        currentPage = 1;
        updateShipmentList();
        updateShipmentListMweb();
    });
    previousBtn.addEventListener("click", ()=>{
        if (currentPage > 1) {
            currentPage--;
            updateShipmentList();
        }
    });
    nextBtn.addEventListener("click", ()=>{
        if (currentPage < Math.ceil(searchFiltered?.length / itemsPerPage)) {
            currentPage++;
            updateShipmentList();
        }
    });
    shipmentsModalCross.addEventListener("click", ()=>{
        shipmentModal.classList.remove("visible");
        document.body.style.overflow = "auto";
    });
    // close modal when clicked outside
    shipmentModal.addEventListener("click", (e)=>{
        const isOutside = !e.target.closest(".shipments-modal-wrapper");
        if (isOutside) {
            shipmentModal.classList.remove("visible");
            document.body.style.overflow = "auto";
        }
    });
}




const $0b96b9c0b6a78b39$export$da847f0704d5fecd = ({ stateClass: stateClass = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).PREVIOUS_SUCCESS, title: title, step: step, dateTime: dateTime })=>`
    <div class="step ${stateClass}">
        <div class="count-circle">
            <a
                href="#"
                title=${title}
            >
            </a>
        </div>
        <div class="info">
            <p class="title">${step}</p>
            <p class="date-text">${dateTime}</p>
        </div>
    </div>
`;
const $0b96b9c0b6a78b39$export$5a0f3019dbf98ee1 = ({ stateClass: stateClass = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).UNATTEMPTED, title: title, step: step, dateTime: dateTime, id: id })=>`
    <div
      class="step ${stateClass}"
      id=${id}
    >
        <div class="count-circle">
            <a href="#" title=${title}></a>
        </div>
        <div class="info">
            <p class="title">${step}</p>
            <p class="date-text">${dateTime}</p>
        </div>
    </div>
`;
const $0b96b9c0b6a78b39$export$29024a40d73fe1f = (src)=>`
   <iframe src= "${src}" class ="overlay-iframe"> </iframe>
`;
const $0b96b9c0b6a78b39$export$64a328fd0c3a62f3 = (orderId, isReverseOrder)=>`

<div class="wrapper mobile-wrapper">

<h2 class="heading" aria-label="Track your Order">Track your Order</h2>

<div class="order-blank">
    <div class="blank-img">
        <img src="picked-up.8990ed77.svg" alt="Order will be picked soon">
    </div>
    <div class="content-blank">
        <div class="orderid-text">Order ID #${orderId}</div>
        <h3>Your ${isReverseOrder ? "return" : ""} order will be picked up soon</h3>
    </div>
</div>

</div>
`;
const $0b96b9c0b6a78b39$export$1fe4eea044e91099 = ()=>`<div class="track-map only-map" aria-label="Google map" id="map-container">`;
const $0b96b9c0b6a78b39$export$71c7af603d22f819 = (orgName)=>`
<div class="wrapper mobile-wrapper">
<h2 class="heading" aria-label="Track your Order">Track your Order</h2>

<div class="order-blank">
    <div class="blank-img">
        <img src="not-found.57e1feca.svg" alt="order not found" role="img">
    </div>
    <div class="content-blank">
        <h3>Order not found</h3>
        <p>The order you are looking for could not be found. Please reach out to  <span id="org-name-span">${orgName}</span></p>
    </div>
</div>

</div>
`;
const $0b96b9c0b6a78b39$export$2c79be02e33eef46 = ()=>{
    return `
  <div class="shipments-modal-wrapper">
        <div class="shipments-modal-header">
          <span class="shipments-modal-heading shipments-text-config"></span>
          <span class="shipments-modal-heading-mweb shipments-text-config"></span>
          <img
            src="xmark-A3AAC2.62711b39.svg "
            class="shipments-modal-cross"
            height="16"
            width="16"
          />
        </div>
        <div class="shipments-modal-body">
          <div class="shipments-modal-search">
            <div class="shipments-modal-search-icon">
              <img src="magnifying-glass.64545ab0.svg" height="16" width="16" />
            </div>
            <input
              type="text"
              placeholder="Search by Shipment ID"
              class="shipments-modal-input"
            />
          </div>
          <div class="shipments-modal-no-results">
            <img src="magnifying-glass.64545ab0.svg" height="42" width="42" />
            <div>
              <div class="shipments-modal-no-results-title">
                No Results Found
              </div>
              <div class="shipments-modal-no-results-desc">
                Try altering your search
              </div>
            </div>
          </div>
          <div class="shipments-modal-list-wrapper">
            <div class="shipments-modal-list-header shipments-text-config">SHIPMENT ID</div>
            <div class="shipments-modal-list"></div>
          </div>
          <div class="shipments-modal-list-wrapper-mweb">
            <div class="shipments-modal-list-header-mweb shipments-text-config"></div>
            <div class="shipments-modal-list-mweb"></div>
          </div>
        </div>
        <div class="shipments-modal-footer">
          <span class="shipments-modal-previous">
            <img
              src="arrow-left-3D445C.a98607c1.svg"
              class="shipments-modal-previous-icon"
              height="16"
              width="16"
            />
            <img
              src="arrow-left-E0E3EB.12e705b4.svg"
              class="shipments-modal-previous-icon-disabled"
              height="16"
              width="16"
            />
            <span class="shipments-modal-previous-text">Previous</span>
          </span>
          <span class="shipments-modal-next">
            <span class="shipments-modal-next-text">Next</span>
            <img
              src="arrow-right-3D445C.840a00ff.svg"
              class="shipments-modal-next-icon"
              height="16"
              width="16"
            />
            <img
              src="arrow-right-E0E3EB.9ec5248b.svg"
              class="shipments-modal-next-icon-disabled"
              height="16"
              width="16"
            />
          </span>
        </div>
      </div>
    `;
};







const $a6df9c40ba402dc9$var$PEC = JSON.parse(sessionStorage.getItem("labels_config"));
const $a6df9c40ba402dc9$export$280f854ae225b23a = (object)=>{
    return Object.keys(object);
};
const $a6df9c40ba402dc9$var$setInnerHtml = (selector, html)=>{
    $(selector)?.html(html);
};
const $a6df9c40ba402dc9$export$5e4fedfba7fc301c = ()=>{
    (0, $c79e50ea9589bb70$export$3eeef3ba48e23c07)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).DELIVERY, (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).ONGOING);
    (0, $c79e50ea9589bb70$export$cc43b60b17b1e2db)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).DELIVERY, "Delivered");
};
const $a6df9c40ba402dc9$export$51fb2f7d41145e45 = ()=>{
    (0, $c79e50ea9589bb70$export$3eeef3ba48e23c07)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).PICKUP, (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).ONGOING);
    (0, $c79e50ea9589bb70$export$cc43b60b17b1e2db)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).PICKUP, "Order is being Picked up");
};
const $a6df9c40ba402dc9$export$ebc037ad8f51f411 = ()=>{
    (0, $c79e50ea9589bb70$export$3eeef3ba48e23c07)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).RIDER_ASSIGNED, (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).COMPLETED);
    console.log($a6df9c40ba402dc9$var$PEC);
    (0, $c79e50ea9589bb70$export$cc43b60b17b1e2db)((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).RIDER_ASSIGNED, ($a6df9c40ba402dc9$var$PEC.riders.singular ?? "Rider") + " Assigned");
    $a6df9c40ba402dc9$export$51fb2f7d41145e45();
};
const $a6df9c40ba402dc9$export$70d1bf7729efff40 = (erCode)=>{
    if (sessionStorage.getItem("labels_config")) {
        const data = JSON.parse(sessionStorage.getItem("labels_config"));
        if ((0, $4ba290e3bd95c603$export$ba28980b1875395d)[erCode] == "Rider Assigned") return data.riders.singular + " Assigned";
        if ((0, $4ba290e3bd95c603$export$ba28980b1875395d)[erCode] == "Shipment Created") return data.shipment.singular + " Created";
    }
    return (0, $4ba290e3bd95c603$export$ba28980b1875395d)[erCode];
};
const $a6df9c40ba402dc9$export$acfd9996e77e0b0a = (position, label, icon)=>{
    let long = position?.long;
    if (!long) long = position?.lon;
    return {
        position: {
            lat: Number(position?.lat),
            lng: Number(long)
        },
        label: label,
        icon: icon
    };
};
const $a6df9c40ba402dc9$export$2758da43f6fad68c = (erCode)=>{
    if ((0, $4ba290e3bd95c603$export$1597ff4b064d820e)[erCode]) return "DELIVERY";
    if ((0, $4ba290e3bd95c603$export$fbc26ae33bd1fca7)[erCode]) return "PICKUP";
};
const $a6df9c40ba402dc9$export$235e1b8b8a7aa7a8 = (erCode)=>{
    if ((0, $4ba290e3bd95c603$export$99b277757456e754)?.includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).COMPLETED;
    return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).COMPLETED;
};
const $a6df9c40ba402dc9$export$1883153485da40a8 = (events)=>{
    const { previousAttempt: previousAttempt, currentAttempt: currentAttempt } = events;
};
const $a6df9c40ba402dc9$export$745ef0877d26b07 = (index, prevFailedEventArray)=>{
    const parentDiv = document.createElement("div");
    const pickupArray = prevFailedEventArray.pickup;
    const dateTimeStampLastFailed = pickupArray[pickupArray?.length - 1]?.timestamp;
    const domElement = `<div
                class="step failedEvent attempted completed"
                id=${`previous-attempt-failed-pickup-${index}`}
                style="display: inline-flex"
              >
                <div class="count-circle completed pick-up">
                  <a href="#" class="state-info" title="Delivery Failed"> </a>
                </div>
                <div class="info">
                  <p
                    class="title attempted-text"
                    aria-label="Delivery Failed"
                  >
                  Pickup Unsuccessful
                  </p>
                  <p class="date-text" id=${`order-failed-date-pickup-${index}`}>
                    ${dateTimeStampLastFailed}
                  </p>
                  <div
                    class="all-update failed-top arrow update-btn-${index}"
                    role="button"
                    aria-label="All Updates"
                  >
                    <a href="#" class="all-update-btn">
                      All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                    </a>
                  </div>

                  <!-- All Updates start-->
                  <div class="topupdate-wrapper topupdate-wrapper-${index}">
                    <div class="allupdate-wrapper" id=${`previous-attempt-${index}`}>
                      <div class="steps ${`del-steps-${index}`}" " id="steps">

                      </div>
                    </div>
                  </div>
                </div>
              </div>`;
    parentDiv.innerHTML = domElement;
    return parentDiv;
};
const $a6df9c40ba402dc9$export$162442360e332c38 = (index, prevFailedEventArray)=>{
    const parentDiv = document.createElement("div");
    const pickupArray = prevFailedEventArray.pickup;
    const dateTimeStampLastFailed = pickupArray[pickupArray.length - 1].timestamp;
    const domElement = `<div
                class="step failedEvent attempted completed"
                id=${`previous-attempt-failed-pickup-${index}`}
                style="display: inline-flex"
              >
                <div class="count-circle completed pick-up">
                  <a href="#" class="state-info" title="Delivery Failed"> </a>
                </div>
                <div class="info">
                  <p
                    class="title attempted-text"
                    aria-label="Delivery Failed"
                  >
                  Return Unsuccessful
                  </p>
                  <p class="date-text" id=${`order-failed-date-pickup-${index}`}>
                    ${dateTimeStampLastFailed}
                  </p>
                  <div
                    class="all-update failed-top arrow update-btn-${index}"
                    role="button"
                    aria-label="All Updates"
                  >
                    <a href="#" class="all-update-btn">
                      All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                    </a>
                  </div>

                  <!-- All Updates start-->
                  <div class="topupdate-wrapper topupdate-wrapper-${index}">
                    <div class="allupdate-wrapper" id=${`previous-attempt-${index}`}>
                      <div class="steps ${`del-steps-${index}`}" " id="steps">

                      </div>
                    </div>
                  </div>
                </div>
              </div>`;
    parentDiv.innerHTML = domElement;
    return parentDiv;
};
const $a6df9c40ba402dc9$var$getTargetDom = (type, event, isReverseOrder, isCurrentSteps, attemptCount, markers, state, failedObject)=>{
    const index = 0;
    let currenttype = type;
    // fetch date , reason and data
    // check if success or failed
    const ERCode = event?.eventCode + (event?.reasonCode ? `-${event?.reasonCode}` : "");
    let stepState = $a6df9c40ba402dc9$export$1604c073c3a8f8ac(ERCode);
    if (!stepState) stepState = $a6df9c40ba402dc9$export$b3fff033469798cd(ERCode);
    const dateTime = event?.timestamp;
    let title = $a6df9c40ba402dc9$export$70d1bf7729efff40(ERCode);
    if (currenttype == "misc" && !Object.keys(failedObject).includes("delivery")) {
        if (event.state === "completed:delivered") {
            currenttype = "delivery";
            stepState = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).SUCCESS;
        }
        if (event.state === "closed:closed") {
            currenttype = "delivery";
            stepState = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
        }
        if (event.state === "completed:delivered" && isReverseOrder) {
            currenttype = "return";
            stepState = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).SUCCESS;
        }
        if (event.state === "closed:closed" && isReverseOrder) {
            currenttype = "return";
            stepState = (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
        }
    }
    title = stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED ? currenttype == "pickup" ? "Pickup Unsuccessful" : "Not Delivered" : title;
    if (isReverseOrder && stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED) {
        if (currenttype == "pickup") title = "Pickup Unsuccessful";
        else title = "Return Failed";
    }
    if (!isReverseOrder && stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED) {
        if (currenttype == "pickup") title = "Pickup Unsuccessful";
        else title = "Not Delivered";
    }
    title = stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).SUCCESS ? currenttype == "delivery" ? "Delivered" : currenttype == "return" ? "Return Received" : title : title;
    let reasoning = $a6df9c40ba402dc9$export$70d1bf7729efff40(ERCode);
    const currentStepClass = isCurrentSteps ? "" : "";
    const pickupFailedClass = isCurrentSteps ? "step-order-failed failed-info" : "failed-info sml-failed";
    const pickupSuccessClass = isCurrentSteps ? event?.eventCode ? "step-completed" : "" : "sml-success";
    const deliveryFailedClass = isCurrentSteps ? "step-order-failed failed-info" : "failed-info sml-failed";
    const deliverySuccessClass = isCurrentSteps ? event?.eventCode ? "step-success " : "" : "sml-success";
    const pickupClass = isCurrentSteps ? "" : "previous-step-pickup";
    const deliveryClass = isCurrentSteps ? "" : "previous-step-delivery";
    const isFailedEvent = stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
    const riderDom = `<div
                            class="step ${currentStepClass} ${isFailedEvent ? "failed-info sml-failed" : "sml-success step-completed"}"
                            id=${`previous-step-assigned-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info">
                              <p class="title">${title}</p>
                              <p class="date-text">${dateTime}</p>
                            </div>
                          </div>`;
    const pickupDom = `                          <div
                            class="${currentStepClass} ${pickupClass} step ${isFailedEvent ? pickupFailedClass : pickupSuccessClass}"
                            id=${`${pickupClass}-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info">
                              <p class="title">${title ?? "Picked Up"}</p>
                              ${isReverseOrder && isFailedEvent && reasoning ? `<p class="reasoning">${reasoning}</p>` : ``}
                              ${dateTime ? `<p class="date-text">${dateTime}</p>` : ""}
                            </div>
                          </div>`;
    const deliveryDom = `                       <div
                            class="${currentStepClass} ${deliveryClass} step ${isFailedEvent ? deliveryFailedClass : deliverySuccessClass}"
                            id=${`${deliveryClass}-${index}`}
                          >
                            <div class="count-circle">
                              <a href="#" title="Completed"> </a>
                            </div>
                            <div class="info ">
                              <p class="title">
                                ${title ? title : isReverseOrder ? "Return Received" : "Delivered"}
                                <!-- Out for Delivery -->
                              </p>

                              ${!isReverseOrder && reasoning ? `<p class="reasoning">${reasoning}</p>` : ""}

                              ${dateTime ? `<p class="date-text">${dateTime}</p>` : ""}
                            </div>
                          </div>`;
    switch(currenttype){
        case "rider":
            return riderDom;
        case "pickup":
            return pickupDom;
        case "delivery":
            return deliveryDom;
        case "return":
            return deliveryDom;
        default:
            return "";
    }
};
const $a6df9c40ba402dc9$var$appendChild = (parentClass, type, childArrayLength, eventArray, isReverseOrder, isCurrentSteps, attemptCount, markers, state, failedObject)=>{
    const parent = document.querySelector(parentClass);
    eventArray.forEach((event)=>{
        const childDom = $a6df9c40ba402dc9$var$getTargetDom(type, event, isReverseOrder, isCurrentSteps, attemptCount, markers, state, failedObject);
        if (childDom) {
            let divElement = document.createElement("div");
            divElement.classList.add("step-wrapper");
            divElement.innerHTML = childDom;
            parent.append(divElement);
        }
    });
};
const $a6df9c40ba402dc9$export$398a12afdc1c3189 = (failedObject, previousAttemptTypes, isReverseOrder, parentClass, isCurrentSteps, attemptCount, markers, state)=>{
    for(let key in failedObject)$a6df9c40ba402dc9$var$appendChild(parentClass, key, failedObject[key].length, failedObject[key], isReverseOrder, isCurrentSteps, attemptCount, markers, state, failedObject);
};
const $a6df9c40ba402dc9$export$3c6a422dc6ece334 = (index, prevFailedEventArray, prevFailedArrayLogic)=>{
    const parentDiv = document.createElement("div");
    const deliveryArray = prevFailedEventArray.delivery;
    const dateTimeStampLastFailed = deliveryArray[deliveryArray.length - 1].timestamp;
    const domElement = `<div
                  class="failedEvent step attempted completed"
                  id=${`previous-attempt-failed-delivery-${index}`}
                  style="display: inline-flex"
                >
                  <div class="count-circle completed pick-up">
                    <a href="#" class="state-info" title="Delivery Unsuccessful"> </a>
                  </div>
                  <div class="info">
                    <p
                      class="title attempted-text"
                      aria-label="Delivery Failed"
                    >
                     Delivery Unsuccessful
                    </p>
                    <p class="date-text"  id="order-failed-date-${index}">
                        ${dateTimeStampLastFailed}
                    </p>
                    <div
                      class="all-update failed-top arrow update-btn-${index}"
                      role="button"
                      aria-label="All Updates"
                    >
                      <a href="#" class = "all-update-btn">
                       All Updates
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8189 3.95112L6.39523 8.86004C6.18643 9.04648 5.87331 9.04648 5.66434 8.86004L0.180326 3.95112C-0.0433027 3.71931 -0.0613703 3.40568 0.139759 3.18069C0.353843 2.94547 0.698831 2.94888 0.91121 3.13978L5.99979 7.72144L11.0894 3.13978C11.3142 2.93944 11.6583 2.95703 11.8605 3.18028C12.0609 3.40568 12.0439 3.71931 11.8189 3.95112Z" fill="#7C3AED"/>
                        </svg>
                      </a>
                    </div>

                    <!-- All Updates start-->
                    <div class="topupdate-wrapper topupdate-wrapper-${index}">
                      <div class="allupdate-wrapper" id="previous-attempt-${index}">
                        <div class="steps ${`del-steps-${index}`}" id="steps">
  


                        </div>
                      </div>
                    </div>
                  </div>
                </div>`;
    parentDiv.innerHTML = domElement;
    return parentDiv;
};
const $a6df9c40ba402dc9$export$1604c073c3a8f8ac = (erCode)=>{
    // handle pickup failed state also here...
    if ((0, $4ba290e3bd95c603$export$93598a6a54685e4f).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).COMPLETED;
    if ((0, $4ba290e3bd95c603$export$2974422dc9ef58c5).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
    if ((0, $4ba290e3bd95c603$export$ef43ed1a1d4cf992).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).ATTEMPTED;
    if ((0, $4ba290e3bd95c603$export$ef331f13fbe04e74).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
};
const $a6df9c40ba402dc9$export$b3fff033469798cd = (erCode)=>{
    if ((0, $4ba290e3bd95c603$export$5fbe065f82ff2dec).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).SUCCESS;
    if ((0, $4ba290e3bd95c603$export$2974422dc9ef58c5).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
    if ((0, $4ba290e3bd95c603$export$dffbaef5ea27a68f).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).ATTEMPTED;
};
const $a6df9c40ba402dc9$export$ec99edd64aefec98 = (erCode)=>{
    if ((0, $4ba290e3bd95c603$export$8751a8cb08b2a1c7).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).SUCCESS;
    if ((0, $4ba290e3bd95c603$export$d0027f3a0bc3986a).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED;
    if ((0, $4ba290e3bd95c603$export$c8ecc1ebe89d4f91).includes(erCode)) return (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).ATTEMPTED;
};
const $a6df9c40ba402dc9$export$8b842260af62a9d = (classNameToExclude)=>{
    let classString = "";
    for(let className in 0, $eb2af9201e5d6d09$export$aa531ef9964b076d)if ((0, $eb2af9201e5d6d09$export$aa531ef9964b076d)[className] !== classNameToExclude) classString += (0, $eb2af9201e5d6d09$export$aa531ef9964b076d)[className] + " ";
    return classString;
};


const $c79e50ea9589bb70$var$setEventDateTime = (identifier, dateTime)=>{
    const dateNode = $(identifier)?.find((0, $eb2af9201e5d6d09$export$5ad47f54758f777).DATE);
    dateNode.text(dateTime);
};
const $c79e50ea9589bb70$export$483236862f8c28fc = (identifier, dateTime)=>{
    $(identifier)?.text(dateTime);
};
const $c79e50ea9589bb70$export$cc43b60b17b1e2db = (identifier, title)=>{
    const titleNode = $(identifier).find((0, $eb2af9201e5d6d09$export$5ad47f54758f777).TITLE);
    titleNode.text(title);
};
const $c79e50ea9589bb70$export$ecdd171b91f7b13a = (identifier, title)=>{
    const titleNode = $(identifier).find((0, $eb2af9201e5d6d09$export$5ad47f54758f777).REASONING);
    titleNode.text(title);
};
const $c79e50ea9589bb70$var$setInnerHtml = (selector, html)=>{
    $(selector)?.html(html);
};
const $c79e50ea9589bb70$export$3eeef3ba48e23c07 = (identifier, stateClass)=>{
    $(identifier)?.addClass(stateClass).removeClass((0, $a6df9c40ba402dc9$export$8b842260af62a9d)(stateClass));
};
const $c79e50ea9589bb70$export$6c80c46ac4f97479 = (identifier1, identifier2)=>{
    $(identifier1)?.css("display", "none");
    $(identifier2)?.css("display", "initial");
};
const $c79e50ea9589bb70$export$f111ecbe32ca3b57 = (shipmentList, orderId)=>{
    if (!shipmentList || !shipmentList.length) return;
    $(document).ready(function() {
        const shipmentsContainer = $(".shipments-text-container");
        const shipmentsContainerMweb = $(".shipments-text-container-mweb");
        const shipmentsText = $("#shipments-id-text");
        const shipmentsTextMweb = $("#shipments-id-text-mweb");
        const shipmentCtaClickHander = ()=>{
            $(".modal-wrapper").addClass("visible");
            $("body").css("overflow", "hidden");
            const template = (0, $0b96b9c0b6a78b39$export$2c79be02e33eef46)();
            $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).SHIPMENTS_MODAL, template);
            (0, $27c0c041de6aa09f$export$c87251e505708bc4)(shipmentList, orderId);
        };
        if (shipmentList && shipmentList?.length == 1 && orderId && shipmentList[0] == orderId) {
            shipmentsContainer.css("display", "none");
            shipmentsContainerMweb.css("display", "none");
            return;
        } else if (shipmentList && shipmentList?.length >= 1) {
            const shipmentsLength = shipmentList.length;
            shipmentsText.text(`${shipmentsLength} Shipments`);
            shipmentsTextMweb.text(`${shipmentsLength} Shipments`);
            shipmentsContainer?.click(function() {
                shipmentCtaClickHander();
            });
            shipmentsContainerMweb?.click(function() {
                shipmentCtaClickHander();
            });
        }
    });
};
const $c79e50ea9589bb70$var$isEmpty = (obj)=>{
    return Object.keys(obj).length == 0;
};
const $c79e50ea9589bb70$var$InitiateMap = (markers, isReverseOrder, attemptCount, eventArray, eventTypes)=>{
    const eventArrayFlat = [];
    let tempMarker = [
        ...!isNaN(markers?.riderLoc?.position?.lat) ? [
            markers?.riderLoc
        ] : [],
        ...!isNaN(markers?.dropLoc?.position?.lat) ? [
            markers?.dropLoc
        ] : []
    ];
    let dropLoc = true;
    if (isNaN(markers?.dropLoc?.position?.lat)) dropLoc = false;
    for(let key in eventArray)eventArray[key].forEach((event)=>{
        eventArrayFlat.push(event);
    });
    const sortedEvents = eventArrayFlat?.sort((a, b)=>{
        const timestampA = new Date(a.timestamp).getTime();
        const timestampB = new Date(b.timestamp).getTime();
        return timestampA - timestampB;
    });
    const filteredSortedEvents = sortedEvents.filter((obj)=>{
        return !$c79e50ea9589bb70$var$isEmpty(obj);
    });
    const lastEvent = filteredSortedEvents[filteredSortedEvents.length - 1];
    const ERCode = lastEvent?.eventCode + (lastEvent?.reasonCode ? `-${lastEvent?.reasonCode}` : "");
    // const ERCode = lastEvent?.eventCode + "-" + lastEvent?.reasonCode;
    const successStates = [
        ...(0, $4ba290e3bd95c603$export$5fbe065f82ff2dec),
        ...isReverseOrder ? (0, $4ba290e3bd95c603$export$93598a6a54685e4f) : [],
        ...(0, $4ba290e3bd95c603$export$4e09a66b1244f7be).SUCCESS
    ];
    const failureStates = [
        ...(0, $4ba290e3bd95c603$export$2974422dc9ef58c5),
        ...(0, $4ba290e3bd95c603$export$ef331f13fbe04e74),
        ...(0, $4ba290e3bd95c603$export$4e09a66b1244f7be).FAILURE
    ];
    if (successStates.includes(ERCode)) {
        if (dropLoc) tempMarker = [
            {
                ...markers.dropLoc,
                icon: (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "map-success.png"
            }
        ];
    }
    if (failureStates.includes(ERCode)) {
        if (dropLoc) tempMarker = [
            {
                ...markers.dropLoc,
                icon: (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "map-failed.png"
            }
        ];
    }
    if (ERCode.includes("E-021") && attemptCount < 3) {
        if (isReverseOrder) $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your return order will be rescheduled");
        else $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your order will be rescheduled");
    }
    const stepState = (0, $a6df9c40ba402dc9$export$b3fff033469798cd)(ERCode);
    if (stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED && attemptCount >= 3) {
        if (isReverseOrder) $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your return order failed");
        else $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Order not delivered");
    }
    (0, $8551cf67c580172e$export$b08464e47b7a3a8)([
        ...tempMarker
    ]);
};
const $c79e50ea9589bb70$export$e33a4f6b06312f34 = (riderLoc, pickupLoc, dropLoc)=>{
    (0, $8551cf67c580172e$export$b08464e47b7a3a8)([
        pickupLoc,
        pickupLoc,
        dropLoc
    ]);
};
const $c79e50ea9589bb70$export$a724ee75e099497d = ({ orderID: orderID, orderState: orderState, isReverseOrder: isReverseOrder, attemptCount: attemptCount, isRecentPickupFailed: isRecentPickupFailed, isRecentDropFailed: isRecentDropFailed })=>{
    const orderIdText = `Order ID #${orderID}`;
    let orderStateText = isReverseOrder ? (0, $eb2af9201e5d6d09$export$66adfd5446cb4c3d)[orderState] : (0, $eb2af9201e5d6d09$export$28139912552c032e)[orderState];
    if (orderState == "inProgress:scheduled" && attemptCount >= 1) orderStateText = "Your order will be re-attempted";
    if (isRecentPickupFailed) orderStateText = "Your order could not be picked up";
    // if (isRecentDropFailed) orderStateText = "Your order will be re-attempted";
    if (isRecentPickupFailed && isReverseOrder) orderStateText = "Your return order could not be picked up";
    // if (isRecentDropFailed) setImage("#order-image1", "#order-image3");
    if (isRecentPickupFailed) $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image1", "#order-image3");
    if (orderState == "inProgress:active" && isReverseOrder) $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image1", "#order-image2");
    if (isRecentDropFailed && isReverseOrder && attemptCount < 3) $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image2", "#order-image1");
    if (isRecentDropFailed && isReverseOrder && attemptCount == 3) $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image2", "#order-image3");
    if (orderState == "executed:delivered" || orderState == "executed:success" || orderState == "closed:success") $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image1", "#order-image2");
    if (orderState == "executed:undelivered" || orderState == "executed:failed" || orderState == "closed:failed") $c79e50ea9589bb70$export$6c80c46ac4f97479("#order-image1", "#order-image3");
    $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_ID, orderIdText);
    $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, orderStateText);
};
const $c79e50ea9589bb70$export$6402781d3d8ea23f = (riderName, isReverseOrder)=>{
    $("#consignee-block")?.css("display", "block");
    $(".cards")?.css("border-bottom-left-radius", "0px");
    $(".cards")?.css("border-bottom-right-radius", "0px");
    let riderNameText = "";
    if (isReverseOrder) riderNameText = riderName + " is on the way to pickup your order.";
    else riderNameText = riderName + " is on the way to deliver your order.";
    $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).CONSIGNEE_NAME, riderNameText);
};
const $c79e50ea9589bb70$export$74475061f76ed749 = ({ countryCode: countryCode, phoneNumber: phoneNumber })=>{
    const code = countryCode;
    const number = phoneNumber;
    const viewportWidth = window.innerWidth;
    const phoneNumberText = code + number;
    const link = $("#tel");
    link.attr("href", "tel:" + phoneNumberText);
    $("#consignee-img1")?.css("display", "block");
    $(".telphone-number")?.css("display", "block");
    // if(viewportWidth>600){
    const showBtn = $("#consignee-img4");
    const message = $(".message-block");
    const copymessage = $(".message-text");
    const closeMessage = $(".message-close");
    showBtn?.css("display", "block");
    const copy = $("#consignee-img2");
    const hideBtn = $("#consignee-img3");
    $c79e50ea9589bb70$var$setInnerHtml(".phone-number", "xxxxxxxxxx");
    const copyTooltip = $(".tooltip");
    showBtn.click(function() {
        hideBtn?.css("display", "block");
        copy?.css("display", "block");
        showBtn?.css("display", "none");
        $c79e50ea9589bb70$var$setInnerHtml(".phone-number", number);
        copyTooltip?.css("display", "block");
    });
    $(document).on("mouseenter", "#consignee-img2", function() {
        // Mouse enter: Apply styles
        $(".tooltip-text").css("display", "block");
    }).on("mouseleave", "#consignee-img2", function() {
        // Mouse leave: Remove styles
        $(".tooltip-text").css("display", "none");
    });
    function copyphoneNumber() {
        var tempInput = $("<input>");
        $("body").append(tempInput);
        // Set the value of the input to the phone number text
        tempInput.val(phoneNumberText).select();
        document.execCommand("copy");
        tempInput.remove();
        message?.css("display", "flex");
        $c79e50ea9589bb70$var$setInnerHtml(copymessage, "Phone number copied successfully!");
        setTimeout(function() {
            message?.css("display", "none");
        // }
        }, 3000);
    }
    copy.click(copyphoneNumber);
    hideBtn?.click(function() {
        hideBtn?.css("display", "none");
        copy?.css("display", "none");
        showBtn?.css("display", "block");
        $c79e50ea9589bb70$var$setInnerHtml(".phone-number", "xxxxxxxxxx");
        copyTooltip?.css("display", "none");
    });
    closeMessage.click(function() {
        message?.css("display", "none");
    });
// }
};
const $c79e50ea9589bb70$export$5e830c5f3cd8a610 = (template)=>{
    $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).WRAPPER, template);
};
const $c79e50ea9589bb70$export$d53efd0d825e2ecb = (epoch)=>{
    const milliseconds = epoch * 1000;
    const dateObject = new Date(milliseconds);
    // Extract individual date and time components
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
    const day = dateObject.getDate();
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const seconds = dateObject.getSeconds();
    // Format the date and time components
    const formattedDate = `${year}-${$c79e50ea9589bb70$var$padNumber(month)}-${$c79e50ea9589bb70$var$padNumber(day)}`;
    const formattedTime = `${$c79e50ea9589bb70$var$padNumber(hours)}:${$c79e50ea9589bb70$var$padNumber(minutes)}:${$c79e50ea9589bb70$var$padNumber(seconds)}`;
    // setInnerHtml(identifierIds.ESTIMATED_DATE, formattedDate);
    $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ESTIMATED_TIME, `Estimated delivery time ${formattedTime}`);
};
function $c79e50ea9589bb70$var$padNumber(number) {
    // Add leading zero if the number is less than 10
    return number < 10 ? "0" + number : number;
}
const $c79e50ea9589bb70$export$3312bf033aac2015 = (eventArray = [
    {
        eventCode: "",
        reasonCode: "",
        timestamp: null
    }
])=>{
    for (let event of eventArray){
        const dateTime = new Date(event?.timestamp).toLocaleString();
        const ERCode = event.eventCode + "-" + event.reasonCode;
        const title = (0, $a6df9c40ba402dc9$export$70d1bf7729efff40)(ERCode);
        const category = checkCategory(ERCode);
        let identifier;
        let stepState;
        switch(category){
            case "DELIVERY":
                identifier = (0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).DELIVERY;
                stepState = (0, $a6df9c40ba402dc9$export$b3fff033469798cd)(ERCode);
                break;
            case "PICKUP":
                identifier = (0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).PICKUP;
                stepState = (0, $a6df9c40ba402dc9$export$1604c073c3a8f8ac)(ERCode);
                break;
        }
        $c79e50ea9589bb70$export$3eeef3ba48e23c07(identifier, stepState);
        $c79e50ea9589bb70$var$setEventDateTime(identifier, dateTime);
        $c79e50ea9589bb70$export$cc43b60b17b1e2db(identifier, title);
    }
};
const $c79e50ea9589bb70$var$isReversePickupFailedCurrent = (eventObject)=>{
    const pickup = eventObject?.pickup[0];
    // const ERCode = pickup?.eventCode + "-" + pickup?.reasonCode;
    const ERCode = pickup?.eventCode + (pickup?.reasonCode ? `-${pickup?.reasonCode}` : "");
    const pickupState = (0, $a6df9c40ba402dc9$export$1604c073c3a8f8ac)(ERCode);
    if (pickupState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d)?.FAILED) return true;
    else return false;
};
const $c79e50ea9589bb70$export$31528493d6494488 = (events, orderId, markers, isReverseOrder, attemptCount, state)=>{
    const { prevFailedArrayNew: prevFailedArrayNew, currentArrayNew: currentArrayNew, prevFailedArrayLogic: prevFailedArrayLogic, flatcurrentArrayLogic: flatcurrentArrayLogic } = events;
    const currentArrayNewTypes = (0, $a6df9c40ba402dc9$export$280f854ae225b23a)(flatcurrentArrayLogic[0] ?? {});
    let currentEventObject = Object.keys(flatcurrentArrayLogic[0] ?? {});
    const isReversePickupFailed = true;
    if (!currentEventObject.includes("pickup")) flatcurrentArrayLogic[0] = {
        ...flatcurrentArrayLogic[0],
        pickup: [
            {}
        ]
    };
    if (!isReverseOrder && !currentEventObject.includes("delivery") && !currentEventObject.includes("misc") || isReverseOrder && !currentEventObject.includes("return") && !currentEventObject.includes("misc")) flatcurrentArrayLogic[0] = {
        ...flatcurrentArrayLogic[0],
        ...isReverseOrder ? $c79e50ea9589bb70$var$isReversePickupFailedCurrent(flatcurrentArrayLogic[0]) ? {} : {
            return: [
                {}
            ]
        } : $c79e50ea9589bb70$var$isReversePickupFailedCurrent(flatcurrentArrayLogic[0]) ? {} : {
            delivery: [
                {}
            ]
        }
    };
    if (!(currentArrayNewTypes?.length > 0) && !(prevFailedArrayLogic?.length > 0)) {
        const template = (0, $0b96b9c0b6a78b39$export$64a328fd0c3a62f3)(orderId, isReverseOrder);
        $c79e50ea9589bb70$export$5e830c5f3cd8a610(template);
        return;
    }
    const parent = document.querySelector(".failed-steps");
    prevFailedArrayLogic.forEach((prevFailedEventArray, index)=>{
        const failedType = prevFailedEventArray?.delivery?.length > 0 ? "delivery" : prevFailedEventArray?.return?.length > 0 ? "return" : "pickup";
        const currentDom = failedType == "delivery" ? (0, $a6df9c40ba402dc9$export$3c6a422dc6ece334)(index, prevFailedEventArray, prevFailedArrayLogic) : failedType == "return" ? (0, $a6df9c40ba402dc9$export$162442360e332c38)(index, prevFailedEventArray, prevFailedArrayLogic) : (0, $a6df9c40ba402dc9$export$745ef0877d26b07)(index, prevFailedEventArray, prevFailedArrayLogic);
        // const currentDom = ispickedUpFailed
        //   ? pickupFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
        //   : deliveryFailedDom(index, prevFailedEventArray, prevFailedArrayLogic);
        parent.appendChild(currentDom);
        const previousAttemptTypes = (0, $a6df9c40ba402dc9$export$280f854ae225b23a)(prevFailedEventArray);
        (0, $a6df9c40ba402dc9$export$398a12afdc1c3189)(prevFailedEventArray, previousAttemptTypes, isReverseOrder, `.del-steps-${index}`, false, attemptCount, markers, state);
    });
    (0, $a6df9c40ba402dc9$export$398a12afdc1c3189)(flatcurrentArrayLogic[0], currentArrayNewTypes, isReverseOrder, `.current-steps`, true, attemptCount, markers, state);
    $c79e50ea9589bb70$var$InitiateMap(markers, isReverseOrder, attemptCount, flatcurrentArrayLogic[0], currentArrayNewTypes);
};
const $c79e50ea9589bb70$export$80a93797572391db = (events, orderId, markers, isReverseOrder, attemptCount, state)=>{
    const { prevFailedArrayLogic: prevFailedArrayLogic, flatcurrentArrayLogic: flatcurrentArrayLogic } = events;
    const currentArrayNewTypes = (0, $a6df9c40ba402dc9$export$280f854ae225b23a)(flatcurrentArrayLogic[0] ?? {});
    let currentEventObject = Object.keys(flatcurrentArrayLogic[0] ?? {});
    if (!currentEventObject.includes("pickup")) flatcurrentArrayLogic[0] = {
        ...flatcurrentArrayLogic[0],
        pickup: [
            {}
        ]
    };
    if (!isReverseOrder && !currentEventObject.includes("delivery") && !currentEventObject.includes("misc") || isReverseOrder && !currentEventObject.includes("return") && !currentEventObject.includes("misc")) flatcurrentArrayLogic[0] = {
        ...flatcurrentArrayLogic[0],
        ...isReverseOrder ? $c79e50ea9589bb70$var$isReversePickupFailedCurrent(flatcurrentArrayLogic[0]) ? {} : {
            return: [
                {}
            ]
        } : $c79e50ea9589bb70$var$isReversePickupFailedCurrent(flatcurrentArrayLogic[0]) ? {} : {
            delivery: [
                {}
            ]
        }
    };
    if (!(currentArrayNewTypes?.length > 0) && !(prevFailedArrayLogic?.length > 0)) {
        const template = (0, $0b96b9c0b6a78b39$export$64a328fd0c3a62f3)(orderId, isReverseOrder);
        $c79e50ea9589bb70$export$5e830c5f3cd8a610(template);
        return;
    }
    // const parent = document.querySelector(".failed-steps");
    // prevFailedArrayLogic.forEach((prevFailedEventArray, index) => {
    //   const failedType =
    //     prevFailedEventArray?.delivery?.length > 0
    //       ? "delivery"
    //       : prevFailedEventArray?.return?.length > 0
    //         ? "return"
    //         : "pickup";
    //   const currentDom =
    //     failedType == "delivery"
    //       ? deliveryFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
    //       : failedType == "return"
    //         ? returnFailedDom(index, prevFailedEventArray, prevFailedArrayLogic)
    //         : pickupFailedDom(index, prevFailedEventArray, prevFailedArrayLogic);
    //   parent.appendChild(currentDom);
    //   const previousAttemptTypes = getObjectKeys(prevFailedEventArray);
    //   HyderateAllUpdatesSection(
    //     prevFailedEventArray,
    //     previousAttemptTypes,
    //     isReverseOrder,
    //     `.del-steps-${index}`,
    //     false,
    //     attemptCount,
    //     markers,
    //     state,
    //   );
    // });
    $c79e50ea9589bb70$var$InitiateMapOnlyMap(markers, isReverseOrder, attemptCount, flatcurrentArrayLogic[0], currentArrayNewTypes);
};
const $c79e50ea9589bb70$var$InitiateMapOnlyMap = (markers, isReverseOrder, attemptCount, eventArray, eventTypes)=>{
    const eventArrayFlat = [];
    let tempMarker = [
        ...!isNaN(markers?.riderLoc?.position?.lat) ? [
            markers?.riderLoc
        ] : [],
        ...!isNaN(markers?.dropLoc?.position?.lat) ? [
            markers?.dropLoc
        ] : []
    ];
    let dropLoc = true;
    if (isNaN(markers?.dropLoc?.position?.lat)) dropLoc = false;
    for(let key in eventArray)eventArray[key].forEach((event)=>{
        eventArrayFlat.push(event);
    });
    const sortedEvents = eventArrayFlat?.sort((a, b)=>{
        const timestampA = new Date(a.timestamp).getTime();
        const timestampB = new Date(b.timestamp).getTime();
        return timestampA - timestampB;
    });
    const filteredSortedEvents = sortedEvents.filter((obj)=>{
        return !$c79e50ea9589bb70$var$isEmpty(obj);
    });
    const lastEvent = filteredSortedEvents[filteredSortedEvents.length - 1];
    const ERCode = lastEvent?.eventCode + (lastEvent?.reasonCode ? `-${lastEvent?.reasonCode}` : "");
    // const ERCode = lastEvent?.eventCode + "-" + lastEvent?.reasonCode;
    const successStates = [
        ...(0, $4ba290e3bd95c603$export$5fbe065f82ff2dec),
        ...isReverseOrder ? (0, $4ba290e3bd95c603$export$93598a6a54685e4f) : [],
        ...(0, $4ba290e3bd95c603$export$4e09a66b1244f7be).SUCCESS
    ];
    const failureStates = [
        ...(0, $4ba290e3bd95c603$export$2974422dc9ef58c5),
        ...(0, $4ba290e3bd95c603$export$ef331f13fbe04e74),
        ...(0, $4ba290e3bd95c603$export$4e09a66b1244f7be).FAILURE
    ];
    if (successStates.includes(ERCode)) {
        if (dropLoc) tempMarker = [
            {
                ...markers.dropLoc,
                icon: (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "map-success.png"
            }
        ];
    }
    if (failureStates.includes(ERCode)) {
        if (dropLoc) tempMarker = [
            {
                ...markers.dropLoc,
                icon: (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "map-failed.png"
            }
        ];
    }
    if (ERCode.includes("E-021") && attemptCount < 3) {
        if (isReverseOrder) $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your return order will be rescheduled");
        else $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your order will be rescheduled");
    }
    const stepState = (0, $a6df9c40ba402dc9$export$b3fff033469798cd)(ERCode);
    if (stepState == (0, $eb2af9201e5d6d09$export$aa531ef9964b076d).FAILED && attemptCount >= 3) {
        if (isReverseOrder) $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Your return order failed");
        else $c79e50ea9589bb70$var$setInnerHtml((0, $eb2af9201e5d6d09$export$cbb21fcb27c5c09a).ORDER_STATE, "Order not delivered");
    }
    (0, $3f7da425cbef4cd8$export$c74460cc9b8dfbe7)([
        ...tempMarker
    ], true);
};



const $019f5a56e0b6bb39$var$isEmpty = (obj)=>{
    return Object.keys(obj).length == 0;
};
const $019f5a56e0b6bb39$var$groupEvents = (eventList, isReverseOrder)=>{
    const grouped = {};
    for (let event of eventList){
        const stateType = $019f5a56e0b6bb39$var$getStateType(event.eventCode, event.reasonCode, isReverseOrder);
        if (stateType) {
            if (!grouped[stateType]) grouped[stateType] = [];
            grouped[stateType].push(event);
        }
    }
    return grouped;
};
function $019f5a56e0b6bb39$export$ae860a607db86bf7(events, isReverseOrder, orderStatus) {
    const sortedEvents = events?.sort((a, b)=>{
        const timestampA = new Date(a.timestamp).getTime();
        const timestampB = new Date(b.timestamp).getTime();
        return timestampA - timestampB;
    });
    let ispickedUp = false;
    let riderIndex = -1;
    let pickupIndex = -1;
    let isRecentPickupFailed = false;
    let isRecentDropFailed = false;
    let isRiderAssigned = false;
    sortedEvents?.forEach((event, index)=>{
        if ((0, $4ba290e3bd95c603$export$93598a6a54685e4f).includes(`${event.eventCode}-${event.reasonCode}`)) pickupIndex = index;
    });
    sortedEvents.forEach((event, index)=>{
        if ((0, $4ba290e3bd95c603$export$99b277757456e754).includes(`${event.eventCode}-${event.reasonCode}`)) riderIndex = index;
    });
    if (pickupIndex == sortedEvents.length - 1) ispickedUp = true;
    if (riderIndex == sortedEvents.length - 1) isRiderAssigned = true;
    const filteredSortedList = sortedEvents.filter((item)=>{
        return !(0, $4ba290e3bd95c603$export$6178b602ab06e887).includes(`${item.eventCode}-${item.reasonCode}`);
    });
    filteredSortedList.forEach((item, index)=>{
        // const ERCODE =
        const ERCode = item?.eventCode + (item?.reasonCode ? `-${item?.reasonCode}` : "");
        if ((0, $4ba290e3bd95c603$export$2974422dc9ef58c5).includes(ERCode) && index == filteredSortedList.length - 1) isRecentDropFailed = true;
        if ((0, $4ba290e3bd95c603$export$ef331f13fbe04e74).includes(ERCode) && index == filteredSortedList.length - 1) isRecentPickupFailed = true;
    });
    let prevFailedArrayNew = [];
    let currentArrayNew = [];
    let currentArrayLogic = [];
    let prevFailedArrayLogic = [];
    let startPtr = 0;
    let startPtrLogic = 0;
    filteredSortedList.forEach((event, index)=>{
        const isRiderAssignedEvent = (0, $4ba290e3bd95c603$export$99b277757456e754).includes(`${event.eventCode}-${event.reasonCode}`);
        const isLastEvent = index == filteredSortedList.length - 1;
        const isTerminalState = (0, $4ba290e3bd95c603$export$5fbe065f82ff2dec).includes(`${event.eventCode}-${event.reasonCode}`) || (0, $4ba290e3bd95c603$export$93598a6a54685e4f).includes(`${event.eventCode}-${event.reasonCode}`) && isReverseOrder || (0, $4ba290e3bd95c603$export$2974422dc9ef58c5).includes(`${event.eventCode}-${event.reasonCode}`) && orderStatus == "closed:failed" && isLastEvent || (0, $4ba290e3bd95c603$export$ef331f13fbe04e74).includes(`${event.eventCode}-${event.reasonCode}`) && isReverseOrder && orderStatus == "closed:failed" && isLastEvent;
        if (isRiderAssignedEvent && index != 0) {
            const prevFailedEvents = filteredSortedList.slice(startPtrLogic, index);
            startPtrLogic = index;
            prevFailedArrayLogic.push($019f5a56e0b6bb39$var$groupEvents(prevFailedEvents, isReverseOrder));
        }
        if (isLastEvent) {
            const currentEvents = filteredSortedList.slice(startPtrLogic, index + 1);
            currentArrayLogic.push($019f5a56e0b6bb39$var$groupEvents(currentEvents, isReverseOrder));
        }
    });
    const flatcurrentArrayLogic = currentArrayLogic.flat();
    const prevFailedFilteredLogicArray = prevFailedArrayLogic.filter((obj)=>{
        return !$019f5a56e0b6bb39$var$isEmpty(obj);
    });
    const flatcurrentArrayLogicFiltered = flatcurrentArrayLogic.filter((obj)=>{
        return !$019f5a56e0b6bb39$var$isEmpty(obj);
    });
    filteredSortedList.forEach((event, index)=>{
        const isFailedEvent = (0, $4ba290e3bd95c603$export$2cd16e5e5b930e8a).includes(`${event.eventCode}-${event.reasonCode}`) || (0, $4ba290e3bd95c603$export$2974422dc9ef58c5).includes(`${event.eventCode}-${event.reasonCode}`) || (0, $4ba290e3bd95c603$export$4e09a66b1244f7be).FAILURE.includes(`${event.eventCode}-${event.reasonCode}`) || (0, $4ba290e3bd95c603$export$ef331f13fbe04e74).includes(`${event.eventCode}-${event.reasonCode}`);
        if (index == filteredSortedList.length - 1) {
            const currentEvents = filteredSortedList.slice(startPtr, index + 1);
            currentArrayNew.push($019f5a56e0b6bb39$var$groupEvents(currentEvents, isReverseOrder));
        }
        if (isFailedEvent && index != filteredSortedList.length - 1) {
            const prevFailedEvents = filteredSortedList.slice(startPtr, index + 1);
            startPtr = index + 1;
            prevFailedArrayNew.push($019f5a56e0b6bb39$var$groupEvents(prevFailedEvents, isReverseOrder));
        }
    });
    const flatCurrentArray = currentArrayNew.flat();
    const filteredcurrentArrayNew = flatCurrentArray.filter((item)=>{
        return !(0, $4ba290e3bd95c603$export$6178b602ab06e887).includes(`${item.eventCode}-${item.reasonCode}`);
    });
    return {
        ispickedUp: ispickedUp,
        prevFailedArrayNew: prevFailedArrayNew,
        prevFailedArrayLogic: prevFailedFilteredLogicArray,
        flatcurrentArrayLogic: flatcurrentArrayLogicFiltered,
        currentArrayNew: filteredcurrentArrayNew[0],
        isRiderAssigned: isRiderAssigned,
        isRecentPickupFailed: isRecentPickupFailed,
        isRecentDropFailed: isRecentDropFailed
    };
}
function $019f5a56e0b6bb39$var$getStateType(eventCode, reasonCode, isReverseOrder) {
    const ERCode = eventCode + (reasonCode ? `-${reasonCode}` : "");
    const { rider: rider, pickup: pickup, delivery: delivery, misc: misc, reverse: reverse } = (0, $4ba290e3bd95c603$export$68977cb6a4e54f58);
    if (pickup?.includes?.(ERCode)) return "pickup";
    if (rider?.includes?.(ERCode)) return "rider";
    if (delivery?.includes?.(ERCode)) return isReverseOrder ? "return" : "delivery";
    if (misc?.includes?.(ERCode)) return "misc";
// if (reverse?.includes?.(ERCode)) return "return"; // Will add proper condition here for return too...
}







var $h5VcY = parcelRequire("h5VcY");





var $c49498d70f69d386$var$settings = ({ tenantDNS: tenantDNS, orderId: orderId, tenantId: tenantId, shipmentId: shipmentId })=>({
        url: orderId ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/orderId/${orderId}` : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/shipmentId/${shipmentId}`,
        method: "GET",
        timeout: 0,
        headers: {
            "x-coreos-request-id": "unAuth1",
            "x-coreos-tid": tenantId
        }
    });
const $c49498d70f69d386$var$isCancelled = (events)=>{
    for(let i = 0; i < events.length; i++){
        const ERCODE = events[i]?.eventCode + (events[i]?.reasonCode ? `-${events[i]?.reasonCode}` : "");
        if ((0, $4ba290e3bd95c603$export$7fac4afed79e1ba9).includes(ERCODE)) return true;
    }
    return false;
};
async function $c49498d70f69d386$var$getMapData() {
    // let showRiderDetails = false;
    let isReverseOrder = false;
    const orderId = (0, $f7544f7c37939b09$export$5c9217d9513756b1)("orderID") || (0, $f7544f7c37939b09$export$5c9217d9513756b1)("orderId");
    const shipmentId = (0, $f7544f7c37939b09$export$5c9217d9513756b1)("shipmentId");
    const tenantConfig = await (0, $h5VcY.getTenantHostName)();
    // get data
    $.ajax($c49498d70f69d386$var$settings({
        tenantDNS: tenantConfig?.tenantDns,
        orderId: orderId,
        tenantId: tenantConfig?.tenantId,
        shipmentId: shipmentId
    })).done(function(response) {
        // data is loaded correctly
        $(".loader").css("display", "none");
        isReverseOrder = false;
        if (response?.data?.order?.shipmentFlow) isReverseOrder = response?.data?.order?.shipmentFlow?.toLowerCase() == "reverse";
        if (isReverseOrder) $("#step-delivered").remove();
        else if (!isReverseOrder) $("#step-return").remove();
        const orgName = response?.data?.orgName;
        // not found or cancelled
        const isOrderCancelled = $c49498d70f69d386$var$isCancelled(response?.data?.shipmentTracking[0]?.events);
        if (!response?.data?.order?.clientOrderId || isOrderCancelled) {
            const template = notFoundTemplate(orgName, "not-found.svg");
            (0, $c79e50ea9589bb70$export$5e830c5f3cd8a610)(template);
            return;
        }
        const sortedEvents = (0, $019f5a56e0b6bb39$export$ae860a607db86bf7)(response?.data?.shipmentTracking[0]?.events, isReverseOrder, response?.data?.order?.state);
        const riderLoc = (0, $a6df9c40ba402dc9$export$acfd9996e77e0b0a)(response?.data?.riderTracking[response?.data?.riderTracking?.length - 1], "Rider", (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "rider_vehicle.svg", "lon");
        const dropLoc = (0, $a6df9c40ba402dc9$export$acfd9996e77e0b0a)(response?.data?.job?.drop?.geolocation, "Drop", (0, $70f199b7b4c6da49$export$18aad79a4efa987d) + "map-home.svg", "long");
        // showRiderDetails = response?.data?.showRiderDetails;
        const markers = {
            riderLoc: riderLoc,
            dropLoc: dropLoc
        };
        (0, $c79e50ea9589bb70$export$80a93797572391db)(sortedEvents, orderId ?? response?.data?.order?.clientOrderId, markers, isReverseOrder, response?.data?.order?.attemptCount, response?.data?.order?.state);
    }).fail((error)=>{
        console.error(error);
    });
}
var $c49498d70f69d386$export$2e2bcd8739ae039 = $c49498d70f69d386$var$getMapData;


var $70f199b7b4c6da49$var$settings = ({ tenantDNS: tenantDNS, orderId: orderId, tenantId: tenantId, shipmentId: shipmentId })=>({
        url: orderId ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/orderId/${orderId}` : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/shipmentId/${shipmentId}`,
        method: "GET",
        timeout: 0,
        headers: {
            "x-coreos-request-id": "unAuth1",
            "x-coreos-tid": tenantId
        }
    });
var $70f199b7b4c6da49$var$consigneeData = ({ tenantDNS: tenantDNS, orderId: orderId, tenantId: tenantId, shipmentId: shipmentId })=>({
        url: orderId ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/rider/order/${orderId}` : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/rider/shipment/${shipmentId}`,
        method: "GET",
        timeout: 0,
        headers: {
            "x-coreos-request-id": "unAuth1",
            "x-coreos-tid": tenantId
        }
    });
var $70f199b7b4c6da49$var$configUI = ({ tenantDNS: tenantDNS, tenantId: tenantId })=>({
        url: `https://${tenantDNS}/app/ui-config/api/app/configs`,
        method: "GET",
        timeout: 0,
        headers: {
            "x-coreos-request-id": "unAuth1",
            "x-coreos-tid": tenantId
        }
    });
const $70f199b7b4c6da49$var$isCancelled = (events)=>{
    for(let i = 0; i < events.length; i++){
        const ERCODE = events[i]?.eventCode + (events[i]?.reasonCode ? `-${events[i]?.reasonCode}` : "");
        if ((0, $4ba290e3bd95c603$export$7fac4afed79e1ba9).includes(ERCODE)) return true;
    }
    return false;
};
const $70f199b7b4c6da49$export$18aad79a4efa987d = "https://dispatch1-assets.getos1.com/assets/";
const $70f199b7b4c6da49$var$getData = async ()=>{
    if (window.location.pathname === "/tracking/map-view/") {
        // added map in HTML
        (0, $c79e50ea9589bb70$export$5e830c5f3cd8a610)((0, $0b96b9c0b6a78b39$export$1fe4eea044e91099)());
        // Hiding footer and header
        document.querySelectorAll(".footerCol").forEach((el)=>el.style.display = "none");
        document.querySelector("header").style.display = "none";
        const time = (0, $f7544f7c37939b09$export$5c9217d9513756b1)("time");
        (0, $c49498d70f69d386$export$2e2bcd8739ae039)();
        setInterval(()=>{
            (0, $c49498d70f69d386$export$2e2bcd8739ae039)();
        }, time ? time * 1000 : 5000);
    } else {
        let showRiderDetails = false;
        let riderStatus = "";
        let isReverseOrder = false;
        const orderId = (0, $f7544f7c37939b09$export$5c9217d9513756b1)("orderID") || (0, $f7544f7c37939b09$export$5c9217d9513756b1)("orderId");
        const shipmentId = (0, $f7544f7c37939b09$export$5c9217d9513756b1)("shipmentId");
        // console.log(orderId,shipmentId);
        const tenantConfig = await (0, $h5VcY.getTenantHostName)();
        $.ajax($70f199b7b4c6da49$var$settings({
            tenantDNS: tenantConfig?.tenantDns,
            orderId: orderId,
            tenantId: tenantConfig?.tenantId,
            shipmentId: shipmentId
        })).done(function(response) {
            //data is loaded correctly
            $(".loader").css("display", "none");
            // if(!sessionStorage.getItem("labels_config")){
            $.ajax($70f199b7b4c6da49$var$configUI({
                tenantDNS: tenantConfig?.tenantDns,
                tenantId: tenantConfig?.tenantId
            })).done(function(response) {
                async function getAlias() {
                    await (0, $9869123fc355fae5$export$a7c25f30fdb2d72b)(response?.data);
                    sessionStorage.setItem("labels_config", JSON.stringify((0, $9869123fc355fae5$export$8bd4336e9f3a70cf)));
                    const event = new Event("localStorageChanged");
                    window.dispatchEvent(event);
                }
                getAlias();
            }).fail((error)=>{
                console.log(error);
            });
            // }
            isReverseOrder = false;
            if (response?.data?.order?.shipmentFlow) isReverseOrder = response?.data?.order?.shipmentFlow?.toLowerCase() == "reverse";
            if (isReverseOrder) $("#step-delivered").remove();
            else if (!isReverseOrder) $("#step-return").remove();
            const orgName = response?.data?.orgName;
            // not found or cancelled
            const isOrderCancelled = $70f199b7b4c6da49$var$isCancelled(response?.data?.shipmentTracking[0]?.events);
            if (!response?.data?.order?.clientOrderId || isOrderCancelled) {
                const template = (0, $0b96b9c0b6a78b39$export$71c7af603d22f819)(orgName, "not-found.svg");
                (0, $c79e50ea9589bb70$export$5e830c5f3cd8a610)(template);
                return;
            }
            const sortedEvents = (0, $019f5a56e0b6bb39$export$ae860a607db86bf7)(response?.data?.shipmentTracking[0]?.events, isReverseOrder, response?.data?.order?.state);
            (0, $c79e50ea9589bb70$export$a724ee75e099497d)({
                orderID: response?.data?.order?.clientOrderId,
                orderState: response?.data?.order?.state,
                isReverseOrder: isReverseOrder,
                attemptCount: response?.data?.order?.attemptCount,
                isRecentPickupFailed: sortedEvents?.isRecentPickupFailed,
                isRecentDropFailed: sortedEvents?.isRecentDropFailed
            });
            (0, $c79e50ea9589bb70$export$f111ecbe32ca3b57)(response?.data?.job?.containers, response?.data?.order?.clientOrderId);
            const riderLoc = (0, $a6df9c40ba402dc9$export$acfd9996e77e0b0a)(response?.data?.riderTracking[response?.data?.riderTracking?.length - 1], "Rider", $70f199b7b4c6da49$export$18aad79a4efa987d + "rider_vehicle.svg", "lon");
            const dropLoc = (0, $a6df9c40ba402dc9$export$acfd9996e77e0b0a)(response?.data?.job?.drop?.geolocation, "Drop", $70f199b7b4c6da49$export$18aad79a4efa987d + "map-home.svg", "long");
            showRiderDetails = response?.data?.showRiderDetails;
            if (showRiderDetails && !isReverseOrder && sortedEvents.ispickedUp || showRiderDetails && isReverseOrder && !sortedEvents.ispickedUp && sortedEvents.isRiderAssigned) {
                const riderName = response?.data?.riderName;
                (0, $c79e50ea9589bb70$export$6402781d3d8ea23f)(riderName, isReverseOrder);
                $.ajax($70f199b7b4c6da49$var$consigneeData({
                    tenantDNS: tenantConfig?.tenantDns,
                    orderId: orderId,
                    tenantId: tenantConfig?.tenantId,
                    shipmentId: shipmentId
                })).done(function(response) {
                    //data is loaded correctly
                    $(".loader").css("display", "none");
                    if (showRiderDetails && !isReverseOrder && sortedEvents.ispickedUp || showRiderDetails && isReverseOrder && !sortedEvents.ispickedUp && sortedEvents.isRiderAssigned) {
                        if (response?.data?.primaryMobile != null) {
                            const countryCode = response?.data?.primaryMobile?.countryCode ?? "";
                            const phoneNumber = response?.data?.primaryMobile?.number ?? "";
                            (0, $c79e50ea9589bb70$export$74475061f76ed749)({
                                countryCode: countryCode,
                                phoneNumber: phoneNumber
                            });
                        }
                    }
                }).fail((error)=>{
                    console.error(error);
                });
            }
            // const makers = [
            // 	// pickupLoc,
            // 	...(!isNaN(riderLoc?.position?.lat) ? [riderLoc] : []),
            // 	dropLoc,
            // ];
            const markers = {
                riderLoc: riderLoc,
                dropLoc: dropLoc
            };
            (0, $c79e50ea9589bb70$export$31528493d6494488)(sortedEvents, orderId ?? response?.data?.order?.clientOrderId, markers, isReverseOrder, response?.data?.order?.attemptCount, response?.data?.order?.state);
        }).fail((error)=>{
            console.error(error);
        });
    }
};
$70f199b7b4c6da49$var$getData();


//# sourceMappingURL=index.b443ee48.js.map
